<script lang="ts">
    import { createEventDispatcher } from 'svelte'

    export let value: boolean = false
    export let disabled = false
    export let autocomplete: string = null
    export let label = ''

    const dispatch = createEventDispatcher()

    $: if (value === undefined) {
        value = false
    }

    function onChange(ev) {
        dispatch('change', ev)
    }
</script>

<div class="form-check form-switch">
    <input {autocomplete} {disabled} class="form-check-input abc" bind:checked={value} on:change={onChange} type="checkbox" role="switch" />
    {#if label}
        <label for="">{label}</label>
    {/if}
</div>
